import React from "react";
import { Reveal } from "@/components/Reveal";
import IntersectGrid from "@/components/IntersectMotif";
import { useLang } from "@/lib/i18n";

// Shared interior page hero with image + heavy overlay.
export default function PageHero({ eyebrow, title, subtitle, image }) {
  const { t } = useLang();
  return (
    <section className="relative min-h-[48vh] flex items-end overflow-hidden pt-28 pb-12 md:pb-16" data-testid="page-hero">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-obsidian/75" />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/40 to-transparent" />
        </div>
      )}
      <IntersectGrid cols={5} rows={3} />
      <div className="container-x relative z-10">
        {eyebrow && <Reveal><p className="eyebrow mb-6">{t(eyebrow)}</p></Reveal>}
        <Reveal delay={0.1}>
          <h1 className="max-w-4xl text-4xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.05] text-ivory">{t(title)}</h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl text-lg md:text-xl leading-relaxed text-soft-stone">{t(subtitle)}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
